// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6992 ? "be74e82d" : chunkId) + "." + {"5152":"194e3bb7a19457fd","6992":"2b15ec8afe38afbc"}[chunkId] + ".js";
};